import React, { useState, useEffect } from 'react';
import config from './internetConfig';
import topTerms from './services/topTerms';

export default function Debug(props) {
	console.info('CONFIG:', config);

	const form = props.form;
	const data = form.data;

	let debug = {
		solr: config.solrRoot,
	};

	let spellchecker = Object.assign({}, config.spellchecker);
	debug.spellchecker = spellchecker;

	debug.topTerms = {
		enabled: Boolean(config.topTerms),
	};
	if (config.topTerms) {
		debug.topTerms.terms = topTerms.getTopQueryTerms(data.query);
	}

	// On form change, update newSearch flag
	useEffect(() => {
		console.info('Form search');
	}, [data]);

	return (
		<div className="debug-pane">
			<dl>
				<dt>SOLR</dt>
				<dd>{config.solrRoot}</dd>

				<dt>Spellcheck</dt>
				<dd>
					<pre>{JSON.stringify(debug.spellchecker)}</pre>
				</dd>

				<dt>Top Terms</dt>
				<dd>{JSON.stringify(debug.topTerms)}</dd>
			</dl>
			<span className="clearfix"></span>
		</div>
	);
}
